import { useCallback, useEffect, useState } from "react"

export default function useClientRect(): [
    ClientRect | undefined,
    (node: HTMLDivElement | null | any) => void,
    () => void,
] {
    const [rect, setRect] = useState<ClientRect | undefined>()
    const [node, setNode] = useState<HTMLDivElement | null | any>()
    const ref = useCallback((node: HTMLDivElement | null | any) => {
        setNode(node)
        if (node !== null) {
            setRect(node.getBoundingClientRect())
        }
    }, [])
    const resetRect = useCallback(() => {
        node && setRect(node.getBoundingClientRect())
    }, [node])

    useEffect(() => {
        window.addEventListener("resize", resetRect)
        return () => window.removeEventListener("resize", resetRect)
    }, [resetRect])

    useEffect(() => {
        if (!node || typeof ResizeObserver === "undefined") {
            return
        }

        let animationFrameID: number | undefined
        const resizeObserver = new ResizeObserver(() => {
            if (animationFrameID !== undefined) {
                window.cancelAnimationFrame(animationFrameID)
            }

            animationFrameID = window.requestAnimationFrame(resetRect)
        })

        resizeObserver.observe(node)

        return () => {
            if (animationFrameID !== undefined) {
                window.cancelAnimationFrame(animationFrameID)
            }
            resizeObserver.disconnect()
        }
    }, [node, resetRect])

    return [rect, ref, resetRect]
}
